import React from "react";

const MastercardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="41"
    height="29"
    viewBox="0 0 41 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.115234"
      y="0.0703125"
      width="40"
      height="28"
      rx="4"
      fill="#0A1330"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1139 19.056C18.9831 20.0317 17.5162 20.6207 15.9134 20.6207C12.3369 20.6207 9.4375 17.688 9.4375 14.0703C9.4375 10.4527 12.3369 7.52002 15.9134 7.52002C17.5162 7.52002 18.9831 8.10902 20.1139 9.08472C21.2447 8.10902 22.7115 7.52002 24.3144 7.52002C27.8909 7.52002 30.7903 10.4527 30.7903 14.0703C30.7903 17.688 27.8909 20.6207 24.3144 20.6207C22.7115 20.6207 21.2447 20.0317 20.1139 19.056Z"
      fill="#ED0006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1172 19.056C21.5097 17.8545 22.3926 16.0667 22.3926 14.0703C22.3926 12.074 21.5097 10.2862 20.1172 9.08471C21.248 8.10902 22.7148 7.52002 24.3177 7.52002C27.8942 7.52002 30.7936 10.4527 30.7936 14.0703C30.7936 17.688 27.8942 20.6207 24.3177 20.6207C22.7148 20.6207 21.248 20.0317 20.1172 19.056Z"
      fill="#F9A000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.1153 19.056C21.5077 17.8545 22.3907 16.0667 22.3907 14.0703C22.3907 12.074 21.5077 10.2862 20.1153 9.08472C18.7228 10.2862 17.8398 12.074 17.8398 14.0703C17.8398 16.0667 18.7228 17.8545 20.1153 19.056Z"
      fill="#FF5E00"
    />
  </svg>
);

export default MastercardIcon;
